var _regeneratorRuntime = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _awaitAsyncGenerator = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/asyncIterator");

var BufferList = require('bl/BufferList');

module.exports = function (size, options) {
  if (typeof size === 'object') {
    options = size;
    size = options.size;
  } else {
    options = options || {};
  }

  if (!size) throw new Error('block size is required');
  return function (source) {
    return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var buffer, started, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              buffer = new BufferList();
              started = false;
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 4;
              _iterator = _asyncIterator(source);

            case 6:
              _context.next = 8;
              return _awaitAsyncGenerator(_iterator.next());

            case 8:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 12;
              return _awaitAsyncGenerator(_step.value);

            case 12:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 31;
                break;
              }

              chunk = _value;
              started = true;
              buffer = buffer.append(chunk);

            case 17:
              if (!(buffer.length >= size)) {
                _context.next = 28;
                break;
              }

              if (!(buffer.length === size)) {
                _context.next = 23;
                break;
              }

              _context.next = 21;
              return buffer;

            case 21:
              buffer = new BufferList();
              return _context.abrupt("break", 28);

            case 23:
              _context.next = 25;
              return buffer.shallowSlice(0, size);

            case 25:
              buffer = buffer.shallowSlice(size);
              _context.next = 17;
              break;

            case 28:
              _iteratorNormalCompletion = true;
              _context.next = 6;
              break;

            case 31:
              _context.next = 37;
              break;

            case 33:
              _context.prev = 33;
              _context.t0 = _context["catch"](4);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 37:
              _context.prev = 37;
              _context.prev = 38;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 42;
                break;
              }

              _context.next = 42;
              return _awaitAsyncGenerator(_iterator.return());

            case 42:
              _context.prev = 42;

              if (!_didIteratorError) {
                _context.next = 45;
                break;
              }

              throw _iteratorError;

            case 45:
              return _context.finish(42);

            case 46:
              return _context.finish(37);

            case 47:
              if (!(started && buffer.length)) {
                _context.next = 55;
                break;
              }

              if (!options.noPad) {
                _context.next = 53;
                break;
              }

              _context.next = 51;
              return buffer;

            case 51:
              _context.next = 55;
              break;

            case 53:
              _context.next = 55;
              return buffer.append(Buffer.alloc(size - buffer.length));

            case 55:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 33, 37, 47], [38,, 42, 46]]);
    }))();
  };
};